import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Prop-tax-system',
    templateUrl: './Prop-tax-system.component.html',
    styleUrls: ['./Prop-tax-system.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PropTaxSystemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
